/// <reference path="../../../../typings/linq/linq.d.ts" />
/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.models {
    declare var _processConfigurationModelSelf: any;
    declare var _processConfigurationTimeout: any;

    export class FormConfigurationModel {
        private logType: string = "FormConfigurationModel";

        public form: Wars.Domain.Model.Form = null;
        public currentStep: Wars.Domain.Model.FormStep;
        public isEditMode: boolean = true;
        public currentStepIndex: number = null;
        public showHtml = true;
        public showJavascript = false;
        public showPreview = false;
        public showSlider = false;
        public process = {};
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;

        constructor(
            private formId: string,
            private processConfigurationId: string,
            private formService: services.FormService,
            private modalService: any,
            private growlService: angular.growl.IGrowlService,
            private $http: ng.IHttpService,
            private contentPageService: services.ContentPageService,
            private formSectionService: services.FormSectionService,
            private $scope: angular.IScope,
            private dataSourceService: services.DataSourceService,
            private $q: angular.IQService,
            private processConfigurationService: services.ProcessConfigurationService) {
            _processConfigurationModelSelf = this;
            _processConfigurationTimeout = null;

            $q.all([
                this.formService.getById(formId).then(f => {
                    if (f.formType === Wars.Domain.Model.Codes.Enums.FormType.Manage) {
                        this.formService.getManageFormConfiguration(formId).then(
                            (form) => {
                                _processConfigurationModelSelf.form = form;
                            });
                    } else {
                        this.formService.getFormConfiguration(formId).then(
                            (form) => {
                                _processConfigurationModelSelf.form = form;
                            });
                    }
                }),
                this.processConfigurationService.getProcessConfigurationEagerLoadConditions(processConfigurationId).then(processConfiguration => {
                    _processConfigurationModelSelf.processConfiguration = processConfiguration;
                })
            ]);

        }
    }
}